import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsService {
  private apiUrl = environment.apiURL + 'account-settings';
  private apiUrlLogs = environment.apiURL + 'email-send-logs';

  constructor(private http: HttpClient) {}

  getSettings(params: any = {}): Observable<any> {
    return this.http.get(this.apiUrl, { params });
  }

  getSetting(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  getSettingByKey(key: string): Observable<any> {
    return this.http.get(this.apiUrl, { params: { key, pageSize: '1' } });
  }

  createSetting(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, body);
  }

  updateSetting(reference: string, body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}/update`, body);
  }

  deleteSetting(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }

  sendMail(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/mail/send`, formData);
  }

  getEmailTimeline(): Observable<any> {
    return this.http.get(`${this.apiUrlLogs}/timeline`);
  }
}
